<template>
  <div class="nf">
    <div class="title row column-s">
      <div class="grid-9 grid-12-s text-center-s">NOTAS FISCAIS</div>
    </div>

    <div v-if="!loader" class="list">
      <template v-if="nfs && nfs.length > 0">
        <div v-for="(nf, i) of nfs" :key="'nf' + nf.id" class="item column">
          <div class="prev row column-s align-center">
            <div class="grid-1 column">
              <span>ID</span><b>{{ nf.id }}</b>
            </div>
            <div class="grid-2 grid-12-s column">
              <span>PREVISÃO DE PAGAMENTO</span
              ><b>{{ nf.dt_previsao_pagamento | date }}</b>
            </div>
            <div class="grid-2 grid-12-s column">
              <span>CICLO</span
              ><!-- O rótulo vem da API desde a sc-9917 (Semanal, Convencional ou Bimensal);
                   a flag fica como recuo para um backend anterior. -->
              <b>{{ nf.tipo_ciclo || (nf.ciclo_semanal ? "Semanal" : "Convencional") }}</b>
            </div>
            <div class="grid-2 grid-12-s column">
              <span>ENVIADO EM</span><b>{{ nf.criado_em | date }}</b>
            </div>
            <div class="grid-2 grid-12-s column">
              <span>CIDADE</span>
              {{ nf.dados_faturamento.doutor.cidade }}
            </div>
            <div class="grid-4 grid-12-s column">
              <span>RAZÃO SOCIAL</span>
              {{ nf.dados_faturamento.doutor.razao_social }}
            </div>
            <div class="grid-1 grid-12-s row justify-end">
              <Button layout="green-go" @click="tg_nf(i, true)" v-if="!nf.show"
                >VALIDAR</Button
              >
              <i
                v-if="nf.show"
                class="fa fa-times close"
                @click="tg_nf(i, false)"
                title="Fechar"
              />
            </div>
          </div>

          <div class="row column-s validate" v-if="nf.show">
            <div class="grid-6 grid-12-s column">
              <h3 class="text-center">DADOS PARA FATURAMENTO</h3>
              <br />
              <h4 class="text-blue">TOTAL</h4>
              <div>
                <b>R$ {{ nf.valor || "0,00" }}</b
                ><br /><br />
              </div>
              <h4 class="text-blue">SUPPORTER</h4>
              <ul class="fature-supporter">
                <li>
                  Razão Social<br />
                  <b>{{ nf.dados_faturamento.doutor.razao_social }}</b>
                </li>
                <li>
                  CNPJ<br />
                  <b>{{ nf.dados_faturamento.doutor.cnpj | cnpj }}</b>
                </li>
                <li>
                  CEP<br />
                  <b>{{ nf.dados_faturamento.doutor.cep | cep }}</b>
                </li>
                <li>
                  Cidade<br />
                  <b>{{ nf.dados_faturamento.doutor.cidade }}</b>
                </li>
                <li>
                  Endereço<br />
                  <b
                    >{{ nf.dados_faturamento.doutor.endereco }}
                    <b v-if="nf.dados_faturamento.doutor.complemento">
                      - {{ nf.dados_faturamento.doutor.complemento }}</b
                    >
                  </b>
                </li>
                <li>
                  E-mail<br />
                  <b>{{ nf.dados_faturamento.doutor.email }}</b>
                </li>
              </ul>
              <br />
              <h4 class="text-blue">NETSUPPORT</h4>
              <ul class="fature-supporter">
                <li>
                  Razão Social<br />
                  <b>{{ nf.dados_faturamento.netsupport.razao_social }}</b>
                </li>
                <li>
                  CNPJ<br />
                  <b>{{ nf.dados_faturamento.netsupport.cnpj | cnpj }}</b>
                </li>
                <li>
                  CEP<br />
                  <b>{{ nf.dados_faturamento.netsupport.cep | cep }}</b>
                </li>
                <li>
                  Cidade<br />
                  <b>{{ nf.dados_faturamento.netsupport.cidade }}</b>
                </li>
                <li>
                  Endereço<br />
                  <b
                    >{{ nf.dados_faturamento.netsupport.endereco
                    }}<b v-if="nf.dados_faturamento.netsupport.complemento">
                      - {{ nf.dados_faturamento.netsupport.complemento }}</b
                    >
                  </b>
                </li>
                <li>
                  E-mail<br />
                  <b>{{ nf.dados_faturamento.netsupport.email }}</b>
                </li>
              </ul>
            </div>

            <div class="grid-6 grid-12-s">
              <embed
                :src="api.admin.nf_file + nf.id_arquivo"
                type="application/pdf"
              />
              <div class="row justify-end controls">
                <form
                  v-if="nf.obs"
                  class="row grid-10"
                  @submit="reprove(nf)"
                  onsubmit="return false"
                >
                  <input
                    v-model="obs"
                    type="text"
                    class="input"
                    placeholder="Motivo da invalidação da Nota Fiscal"
                    required
                  />
                  &nbsp;&nbsp;
                  <Button layout="red-go">
                    <i class="fa fa-send" />
                    ENVIAR</Button
                  >
                </form>
                &nbsp;&nbsp;
                <Button v-if="!nf.obs" layout="red-go" @click="tg_obs(i, true)">
                  <i class="fa fa-times" />
                  REPROVAR</Button
                >

                &nbsp;&nbsp;

                <Button layout="green-go" @click="aprove(nf)">
                  <i class="fa fa-check" />APROVADO</Button
                >
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="column align-center">
          <br /><br /><br /><br />
          <img src="../../assets/img/error.svg" alt="erro" width="70" />
          <br />
          <b> Nenhuma nota para validar.</b>
        </div>
      </template>
    </div>
    <div v-else class="column align-center justify-center">
      <Loader />
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Button from "@/components/Button.vue";
import Loader from "@/components/Loader.vue";
import Api from "@/conf/Api.js";

export default {
  name: "NF",
  components: { Button, Loader },
  data() {
    return {
      loader: true,
      nfs: [],
      api: Api,
      obs: "",
    };
  },
  beforeMount() {
    this.list();
  },
  methods: {
    ...mapActions("admin", ["LOAD_NFS", "NF_VALIDATE"]),
    reprove(nf) {
      if (confirm("Deseja reprovar esta Nota Fiscal?"))
        this.NF_VALIDATE({
          id_nota_fiscal: nf.id,
          operacao: "invalidado",
          motivo: this.obs,
        })
          .then(() => this.list())
          .catch(() => this.list());
    },
    aprove(nf) {
      if (confirm("Deseja aprovar esta Nota Fiscal?"))
        this.NF_VALIDATE({
          id_nota_fiscal: nf.id,
          operacao: "validado",
        })
          .then(() => this.list())
          .catch(() => this.list());
    },
    list() {
      this.LOAD_NFS({ status: "pendente" })
        .then((r) => {
          this.nfs = r.data;
          this.loader = false;
          this.$forceUpdate();
        })
        .catch(() => {
          this.nfs = [];
          this.loader = false;
          this.$forceUpdate();
        });
    },
    tg_nf(index, value) {
      this.nfs[index].show = value;
      this.$forceUpdate();
    },
    tg_obs(index, value) {
      this.nfs[index].obs = value;
      this.$forceUpdate();
    },
  },
  mounted() {
    this.$parent.$children[0].changeMenu("nf");
  },
};
</script>

<style lang="scss" scoped>
@use "@/assets/scss/vars.scss" as *;
.nf {
  padding: 42px 35px;
  color: $gray-3;
  @media (max-width: $small) {
    padding: 7px;
  }

  .title {
    font-size: 26px;
    font-weight: bold;
    color: $gray-4;
    text-transform: uppercase;

    @media (max-width: $small) {
      margin-top: 38px;
      margin-bottom: 0px;
    }
  }
  .list {
    margin-top: 25px;

    .item {
      margin-bottom: 13px;
      border-radius: 5px;
      background: $white;
      padding: 10px 15px;
      box-shadow: $shadow;
      embed {
        width: 100%;
        height: 900px;
      }
      span {
        color: $gray-9;
      }
      .controls {
        margin-top: 14px;
        padding-bottom: 12px;
      }
      .close {
        font-size: 26px;
        padding: 15px 10px;
        &:hover {
          color: $red-1;
          cursor: pointer;
        }
      }
      .prev {
        div {
          @media (max-width: $small) {
            margin-bottom: 12px;
          }
        }
      }
      .validate {
        margin-top: 20px;
        margin: 10px;
        padding-top: 15px;
        border-top: 1px solid #ccc;
      }
      .fature {
        &-supporter {
          li {
            margin-bottom: 10px;
          }
        }
      }
    }
  }

  .loader {
    margin-top: 15%;
  }
}
</style>